import DateOfBirthWrapper from 'features/signup/DateOfBirth/DateOfBirthWrapper';
import React from 'react';

export default function SignupDobPage() {
  return <DateOfBirthWrapper />;
}
